// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2GcOt","productName":"Table_productName__2WKXQ"};